function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Leisure = function Leisure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "m13.83 2 .11.382c4.459-.443 6.737 1.321 7.72 2.448.86.99 1.35 2.2 1.15 2.88a.755.755 0 0 1-1.04.48c-2.52-1.18-3.82.55-3.96.75-.2.29-.59.4-.92.26-.669-.289-1.27-.416-1.802-.437L17.63 21.85c.08.41-.19.8-.59.88q-.04.001-.078.005-.033.005-.062.005v.01c-.35 0-.67-.25-.74-.61L13.607 8.995a3.6 3.6 0 0 0-1.517 1.065c-.23.31-.67.39-1 .19-2.26-1.4-3.95.44-4.13.65-.15.17-.36.26-.57.26l.01-.01c-.09 0-.18-.01-.26-.05a.76.76 0 0 1-.49-.7c0-.672.194-6.352 6.789-7.785l-.059-.205a.76.76 0 0 1 .52-.93c.39-.12.81.12.93.52M5.783 20.3c-1.314-.465-2.236-1.408-2.873-2.9-.79-1.843-1.434-3.633-1.586-4.056l-.034-.094c-.14-.39.07-.82.46-.96s.82.07.96.46c0 .02.7 2 1.58 4.05.73 1.71 1.77 2.35 3.81 2.35 1.89 0 3.39-1.3 3.4-1.31.31-.27.78-.24 1.06.07.27.31.24.78-.07 1.06a7.5 7.5 0 0 1-1.737 1.082L12.55 21.4a.75.75 0 0 1-.9 1.2l-2.48-1.86-5.83 1.97c-.08.03-.16.04-.24.04-.31 0-.6-.2-.71-.51-.13-.39.08-.82.47-.95zM10.85 4.71c-2.188 1.026-3.083 2.704-3.45 4 .865-.428 1.96-.667 3.158-.34-.114-1.144-.084-2.519.292-3.66m2.45-.737.21-.033-.01.01.226-.03c1.387.056 2.205 2.389 2.508 3.48-1.761-.397-3.197.064-4.177.698-.113-1.445-.017-3.744 1.244-4.125m4.39 3.041c-.274-1.04-.751-2.246-1.458-3.16 1.89.166 3.094.843 3.828 1.486.39.34.68.7.88 1.01a4.4 4.4 0 0 0-3.25.664",
    clipRule: "evenodd"
  }));
};
export default Leisure;
Leisure.displayName = 'Leisure';